export const SHOW_MODAL = 'akommo-search/modal/SHOW_MODAL'
export const HIDE_MODAL = 'akommo-search/modal/HIDE_MODAL'

export const CLOSE_MODAL = 'akommo-search/modal/CLOSE_MODAL'
export const SUBMIT_MODAL = 'akommo-search/modal/SUBMIT_MODAL'



// WEBPACK FOOTER //
// ./src/redux/modules/modal/types.js